import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.CollectionUpdates', null, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('updates', true);
        tmp0_serialDesc.addElement_5pzumi_k$('remove', true);
        tmp0_serialDesc.addElement_5pzumi_k$('overload', true);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_cre5l3_k$(typeSerial0, typeSerial1) {
        return $serializer().new_com_lightningkite_services_database_CollectionUpdates_$serializer_285gf0_k$(typeSerial0, typeSerial1);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_cre5l3_k$(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_CollectionUpdates_$serializer_drzc8d_k$();
      }
      static new_com_lightningkite_services_database_CollectionUpdates_$serializer_drzc8d_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.CollectionUpdates', $this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('updates', true);
        tmp0_serialDesc.addElement_5pzumi_k$('remove', true);
        tmp0_serialDesc.addElement_5pzumi_k$('overload', true);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_kmjjvz_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.updates_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.typeSerial0__1), value.updates_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.remove_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.typeSerial1__1), value.remove_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.overload_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.overload_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.condition_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kmjjvz_k$(encoder, value instanceof CollectionUpdates() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.typeSerial1__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (LinkedHashSetSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (LinkedHashSetSerializer())(this.typeSerial1__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, new (ConditionSerializer())(this.typeSerial0__1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CollectionUpdates().new_com_lightningkite_services_database_CollectionUpdates_sw3ncd_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (LinkedHashSetSerializer())(this.typeSerial0__1), new (LinkedHashSetSerializer())(this.typeSerial1__1), BooleanSerializer_getInstance(), get_nullable(new (ConditionSerializer())(this.typeSerial0__1))];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, this.typeSerial1__1];
      }
      static new_com_lightningkite_services_database_CollectionUpdates_$serializer_285gf0_k$(typeSerial0, typeSerial1) {
        var $this = this.new_com_lightningkite_services_database_CollectionUpdates_$serializer_drzc8d_k$();
        $this.typeSerial0__1 = typeSerial0;
        $this.typeSerial1__1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CollectionUpdatesClass;
function CollectionUpdates() {
  if (CollectionUpdatesClass === VOID) {
    class $ {
      constructor(updates, remove, overload, condition) {
        Companion_getInstance();
        var tmp;
        if (updates === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = updates;
        }
        updates = tmp;
        var tmp_0;
        if (remove === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = remove;
        }
        remove = tmp_0;
        overload = overload === VOID ? false : overload;
        condition = condition === VOID ? null : condition;
        this.updates_1 = updates;
        this.remove_1 = remove;
        this.overload_1 = overload;
        this.condition_1 = condition;
      }
      toString() {
        return 'CollectionUpdates(updates=' + toString(this.updates_1) + ', remove=' + toString(this.remove_1) + ', overload=' + this.overload_1 + ', condition=' + toString_0(this.condition_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.updates_1);
        result = imul(result, 31) + hashCode(this.remove_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.overload_1) | 0;
        result = imul(result, 31) + (this.condition_1 == null ? 0 : this.condition_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CollectionUpdates()))
          return false;
        if (!equals(this.updates_1, other.updates_1))
          return false;
        if (!equals(this.remove_1, other.remove_1))
          return false;
        if (!(this.overload_1 === other.overload_1))
          return false;
        if (!equals(this.condition_1, other.condition_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_CollectionUpdates_sw3ncd_k$(seen0, updates, remove, overload, condition, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.updates_1 = emptySet();
        } else
          $this.updates_1 = updates;
        if (0 === (seen0 & 2)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.remove_1 = emptySet();
        } else
          $this.remove_1 = remove;
        if (0 === (seen0 & 4))
          $this.overload_1 = false;
        else
          $this.overload_1 = overload;
        if (0 === (seen0 & 8))
          $this.condition_1 = null;
        else
          $this.condition_1 = condition;
        return $this;
      }
    }
    initMetadataForClass($, 'CollectionUpdates', CollectionUpdates, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    CollectionUpdatesClass = $;
  }
  return CollectionUpdatesClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstancelkcs3vv5v0ys,
};
//endregion

//# sourceMappingURL=CollectionUpdates.mjs.map
